
import { Component, Vue } from 'vue-property-decorator';

import Form10ProcessHeader from "@/components/process/Form10/components/Form10ProcessHeader.vue";
import Form10StyleOfProceeding from "@/components/process/Form10/components/Form10StyleOfProceeding.vue";
import { form10StatusInfoType } from '@/types/Information/Form10';

@Component({
    components:{
        Form10ProcessHeader,        
        Form10StyleOfProceeding
    }
})
export default class FillForm10 extends Vue {

    stepsCompleted = {} as form10StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
